export const dataReducer = (state, action) => {
  switch (action.type) {
    case "FETCH_SUCCESS":
      return {
        ...state,
        [action.stateType]: {
          ...state[action.stateType],
          data: action.payload.data, // Simpan data yang diterima di stateType yang sesuai
          pagination: action.payload.pagination,
          loading: false,
          error: null,
        },
      };
    // case "ADD_DATA":
    //   return {
    //     ...state,
    //     [action.stateType]: {
    //       ...state[action.stateType], // Pertahankan state untuk stateType yang sesuai
    //       data: [
    //         action?.payload?.data, // Tambahkan produk baru dengan id sebagai kunci
    //         ...state[action?.stateType]?.data, // Pertahankan data yang sudah ada (jika berbentuk objek)
    //       ],
    //       pagination: state[action.stateType].pagination, // Pertahankan pagination yang ada
    //       loading: false, // Set loading menjadi false
    //       error: null, // Reset error jika ada
    //     },
    //   };

    case "ADD_DATA":
      return {
        ...state,
        [action.stateType]: {
          ...state[action.stateType], // Pertahankan state untuk stateType yang sesuai
          data: [
            action?.payload.data, // Tambahkan produk baru
            ...(Array.isArray(state[action.stateType]?.data)
              ? state[action.stateType].data
              : []), // Pastikan data adalah array
          ],
          pagination: state[action.stateType]?.pagination || {}, // Pertahankan pagination jika ada
          loading: false, // Set loading menjadi false
          error: null, // Reset error jika ada
        },
      };

    //   case "ADD_DATA":
    // if (!action.stateType || !Array.isArray(state[action.stateType]?.data)) {
    //     console.error(`Invalid stateType or data: ${action.stateType}`);
    //     return state;
    // }

    // return {
    //     ...state,
    //     [action.stateType]: {
    //         ...state[action.stateType],
    //         data: [
    //             action?.payload.data, // Tambahkan produk baru
    //             ...state[action.stateType].data, // Pertahankan data yang sudah ada
    //         ],
    //         pagination: state[action.stateType]?.pagination || {},
    //         loading: false,
    //         error: null,
    //     },
    // };

    // case 'UPDATE_DATA':
    //     return {
    //         ...state,
    //         [action.stateType]: {
    //             ...state[action.stateType],  // Pertahankan stateType lainnya
    //             data: {
    //                 ...state[action.stateType].data,  // Pertahankan data yang ada
    //                 [action.payload.id]: {            // Update produk berdasarkan ID
    //                     ...state[action.stateType].data[action.payload.id],  // Pertahankan data produk sebelumnya
    //                     ...action.payload.data  // Gabungkan perubahan dari payload
    //                 }
    //             },
    //             pagination: state[action.stateType].pagination,  // Pertahankan pagination yang ada
    //             loading: false,  // Set loading menjadi false
    //             error: null  // Reset error jika ada
    //         }
    //     };
    case "UPDATE_DATA":
      return {
        ...state,
        [action.stateType]: {
          ...state[action.stateType],
          data: state[action?.stateType].data?.map(
            (item) => {
              return item.id === action.payload.data.id
                ? { ...item, ...action.payload.data } // Update item if IDs match
                : item;
            } // Keep other items unchanged
          ),
          pagination: state[action.stateType].pagination, // Preserve existing pagination
          loading: false, // Set loading to false
          error: null, // Reset any existing error
        },
      };
    case "REMOVE_DATA":
      const remainingData = state[action.stateType].data.filter(
        (callback) => callback.id !== action.payload
      );
      return {
        ...state,
        [action.stateType]: {
          ...state[action.stateType],
          data: remainingData, // Tetapkan objek data baru tanpa produk yang dihapus
          pagination: state[action.stateType].pagination, // Pertahankan pagination yang ada
          loading: false, // Set loading menjadi false
          error: null, // Reset error
        },
      };
    case "ERROR":
      return {
        ...state,
        [action.stateType]: {
          ...state[action.stateType],
          error: action.payload, // Set error untuk stateType yang sesuai
          loading: false,
        },
      };
    case "LOADING":
      return {
        ...state,
        [action.stateType]: {
          ...state[action.stateType],
          loading: true, // Set loading untuk stateType yang sesuai
          error: null,
        },
      };
    default:
      return state;
  }
};

export const initialState = {
  customers: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  labels: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  campaigns: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  users: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  roles: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  permissions: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  products: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
};
